import React, { createContext, useEffect, useReducer } from "react";

import { contextConstants } from "context/constants";
import { contextReducers } from "context/reducers";
import { contextActions } from "context/actions";

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [state, dispatch] = useReducer(
    contextReducers.auth.reducer,
    contextReducers.auth.initialState
  );

  const initUser = async () => {
    const user = await contextActions.auth.initUser();

    dispatch({
      type: contextConstants.auth.USER_UPDATED,
      payload: { user },
    });
  };

  const initUserType = async () => {
    const { isManager, isAdmin } =
      await contextActions.auth.initUserTypeValues();

    dispatch({
      type: contextConstants.auth.USER_TYPE_UPDATED,
      payload: { isManager, isAdmin },
    });
  };

  const auth = {
    ...state,
  };

  useEffect(() => {
    (async () => {
      await initUser();
      await initUserType();
    })();
  }, []);

  return <AuthContext.Provider value={auth}>{children}</AuthContext.Provider>;
};
